import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=090d4b4a&lang=pug"
import script from "./user-card.vue?vue&type=script&lang=ts"
export * from "./user-card.vue?vue&type=script&lang=ts"
import style0 from "./user-card.vue?vue&type=style&index=0&id=090d4b4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports